/* eslint "react-hooks/exhaustive-deps": "off" */
import React, { useState, useEffect, useMemo } from "react";
import { useTranslation } from "react-i18next";
import BarGraph from "@components/graphStatistics/Bar/Graphs";

export default function AgeGraph({ ages,details }) {
  const { t: statTranslator } = useTranslation("pages.employés.statistics");
  const [graphData, setGraphData] = useState({});

  const maxAges = Math.max(...ages.map((emp) => emp.age));

  const graphOptions = useMemo(() => {
    return {
      //Customize chart options
      tooltips: {
        bodyFontSize: 15,
        // caretSize: 10,
        titleFontSize: 13,
        callbacks: {
          title: (item) => item[0].label,
          label: (item) => {
            return +item.value + ` ${statTranslator("ans")}`;
          }
        }
      },
      legend: {
        display: false
      },
      scales: {
        yAxes: [
          {
            ticks: {
              min: 0,
              stepSize: Math.ceil(maxAges / 7)
            },
          }
        ],
        xAxes: [
          {
            maxBarThickness: 50
          }
        ]
      }
    };
  }, [maxAges]);

  useEffect(() => {
    const dataAge = {
      labels: ages?.map((x) => x.fullname) || [],
      datasets: [
        {
          label: statTranslator("Années"),
          backgroundColor: "#FFB0C1",
          borderColor: "#E5879F",
          borderWidth: 0.5,
          data: ages?.map((x) => x.age) || []
        }
      ]
    };

    setGraphData(dataAge);
  }, [ages]);
  
  
  return (
    <BarGraph
      legends={
        <div className="arh-flex arh-space-x-3 arh-items-center">
          <span className="arh-w-3 arh-h-3 arh-bg-[#fdb0c0]"></span>
          <span className="arh-font-poppins arh-text-xs arh-text-darkColor arh-font-medium">
            {statTranslator("Nombre d’années")}
          </span>
        </div>
      }
      graphData={graphData}
      title={statTranslator("Âge")}
      graphOptions={graphOptions}
      target="age"
      description={
        <>
          <div className="arh-text-base arh-font-medium ">{statTranslator("Chiffres en détail")}</div>
          <div className="arh-flex arh-flex-col arh-space-y-2 ">
              <div className="arh-text-xs"><span className="arh-mr-2">{statTranslator("Employé le plus jeune")}:</span> <span className="arh-text-[#859298] ">{details?.minAge  ? `${details?.minAge} ${statTranslator("ans")}`:"-"}</span></div>
              <div className="arh-text-xs"><span className="arh-mr-2">{statTranslator("Moyenne d’âge")}:</span> <span className="arh-text-[#859298] ">{details?.avgAge  ? `${details?.avgAge} ${statTranslator("ans")}`:"-"}</span></div>
              <div className="arh-text-xs"><span className="arh-mr-2">{statTranslator("Employé le plus agé")}:</span> <span className="arh-text-[#859298] ">{details?.maxAge  ? `${details?.maxAge} ${statTranslator("ans")}`:"-"}</span></div>
          </div>
        </>
      }
    />
  );
}
